import { PropertyMetricCollectionJSON, UnitTypeJSON } from './';
import * as model from './';

export interface FloorPlanJSON extends UnitTypeJSON {
  floorplan: string;
  floorplanDisplay: string;
  bedroomCount: string | number;
  bathroomCount: string | number;
}

export interface FloorPlanMetricJSON extends PropertyMetricCollectionJSON {
  floorplan: string;
  totalunitcount: number;
  totalsquarefootage: number;
}

export interface BedRoomTypeJSON extends PropertyMetricCollectionJSON {
  avgsqftperbed: number;
  bedroomtypedisplay: string;
}

export class FloorPlan extends model.EntityBase implements FloorPlanJSON {
  unitType: string;
  floorplan: string;
  floorplanDisplay: string;
  unitCount: number;
  totalSquareFootage: number;
  bedroomCount: number;
  bathroomCount: number;

  constructor(json: FloorPlanJSON) {
    super(json);
    if (!json) return this;

    this.unitType = json.unitType;
    this.floorplan = json.floorplan;
    this.floorplanDisplay = json.floorplanDisplay;
    this.unitCount = json.unitCount;
    this.totalSquareFootage = json.totalSquareFootage;
    this.bedroomCount = +json.bedroomCount;
    this.bathroomCount = +json.bathroomCount;
  }

  public static sortByUnitType(left: FloorPlanJSON, right: FloorPlanJSON): number {
    if (!left) return 1;
    if (!right) return -1;

    if (left.unitType === 'E') return -1;
    if (right.unitType === 'E') return 1;

    return +left.unitType <= +right.unitType ? -1 : 1;
  }
}

export class FloorPlanMetric extends FloorPlan implements FloorPlanJSON {
  metrics: model.AercoMetric;

  constructor(details: FloorPlanJSON, metrics: FloorPlanMetricJSON) {
    super(details);
    // this.metrics = metrics && metrics.metrics ? model.AercoMetric.fromJSON(metrics.metrics) : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/model/FloorPlan.ts